import { useMemo } from 'react';
import { BaseProps, BoardCard, BoardColumn } from '../types';
import KanbanBoardColumn from './column';

interface KanbanBoardColumnsProps extends BaseProps {
    columns?: BoardColumn[];
    cards?: Record<string, BoardCard[]>;
}

const KanbanBoardColumns = ({
    columns = [],
    cards = {},
    cardComponent,
    columnHeaderComponent,
    columnFooterComponent,
    columnInfoComponent,
    onAddCardClick,
    onSettingsClick,
    onColumnExpand,
    onColumnCollapse,
    onRequestColumnEdit,
    onRequestColumnDelete,
}: KanbanBoardColumnsProps) => {
    const columnsList = useMemo(
        () => columns.map(
            (column, index) => (
                <KanbanBoardColumn
                    key={`kanban-board-column__${column.name}`}
                    index={index}
                    name={column.name}
                    title={column.label}
                    column={column}
                    cards={cards[column.name]}
                    cardComponent={cardComponent}
                    columnHeaderComponent={columnHeaderComponent}
                    columnFooterComponent={columnFooterComponent}
                    columnInfoComponent={columnInfoComponent}
                    onAddCardClick={onAddCardClick}
                    onSettingsClick={onSettingsClick}
                    onColumnExpand={onColumnExpand}
                    onColumnCollapse={onColumnCollapse}
                    onRequestColumnEdit={onRequestColumnEdit}
                    onRequestColumnDelete={onRequestColumnDelete}
                />
            ),
        ),
        [
            columns,
            cards,
            cardComponent,
            columnHeaderComponent,
            columnInfoComponent,
            columnFooterComponent,
            onAddCardClick,
            onSettingsClick,
            onRequestColumnEdit,
            onRequestColumnDelete,
            onColumnExpand,
            onColumnCollapse,
        ],
    );

    return columnsList;
};

export default KanbanBoardColumns;
